// useCanUsePip — gate de capabilities pro PiP.
//
// PiP roda um 2º MediaPlayer independente (NÃO reusa singleton) pra
// permitir "espiar enquanto assiste outro canal". Custo:
//   - 2 streams MSE simultâneos (~60-120MB buffer combinado)
//   - 2 decode pipelines H264 (alguns chips só fazem 1 hardware)
//   - 2 conexões TCP de rede
//
// Em vlow (Tizen <4, webOS <4, FireTV <6, RAM <1.5GB): risco real
// de travar/crashar. Decoder de hardware single-channel cai pro
// software → CPU 100% → page freeze.
//
// Em low (Tizen 4, webOS 4, FireTV 6, RAM 1.5-2GB): risco menor mas
// existe — buffer MSE pode estourar memória após alguns minutos.
//
// Em mid+ (Tizen 5+, webOS 5+, FireTV 7+, RAM 2GB+): OK.
//
// Decisão: bloquear PiP em vlow E low. Toast esconde botão "Espiar"
// silenciosamente — sem mensagem "não suportado" (UX clean: feature
// simplesmente não está ali).

import { useCapability } from '@app-iptv/device/react'

export function useCanUsePip(): boolean {
  const tier = useCapability('cpuTier')
  // mid, high, ultra — OK. vlow, low — bloqueado.
  return tier === 'mid' || tier === 'high' || tier === 'ultra'
}
